import { change } from 'redux-form'
import { sendServicesAndDateTime } from 'components/Appointment/actions'
import { submitAppointment } from 'components/AppointmentConfirmationPage/AppointmentInfo/actions'
import { sendGoogleConversionTracker } from 'components/QuickAppointmentPage/ThreeStepper/helpers'
import { APPOINTMENT_FORM_NAME, SERVICES_COMMENT_FIELD_NAME } from 'constant'

export const resetServiceComment = () => dispatch =>
  dispatch(change(APPOINTMENT_FORM_NAME, SERVICES_COMMENT_FIELD_NAME, ''))

export const submit3StepperApptRequest = ({
  phoneNumber,
  firstName,
  lastName,
  email,
  userPlan,
  setCurrentStepIndex,
  setIsLoading,
  promonOffers = false,
  termsConditions
}) => dispatch =>
  dispatch(sendServicesAndDateTime(true, true, true))
    .then(() => dispatch(submitAppointment({
      phoneNumber,
      firstName,
      lastName,
      email,
      userPlan,
      setCurrentStepIndex,
      setIsLoading,
      from3Stepper: true,
      promonOffers,
      termsConditions
    })))
    .then(() => sendGoogleConversionTracker())
